import { render, staticRenderFns } from "./AnnullaSpecifiche.vue?vue&type=template&id=06adaa35"
import script from "./AnnullaSpecifiche.vue?vue&type=script&lang=js"
export * from "./AnnullaSpecifiche.vue?vue&type=script&lang=js"
import style0 from "./AnnullaSpecifiche.vue?vue&type=style&index=0&id=06adaa35&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports